import React, { Fragment, useState } from 'react';
import Type from 'prop-types';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Grid,
  List as MuiList,
  Typography,
} from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { splittingArraysObjectsByTypes } from 'utils/math';
import FileItem from '../FileItem';
import styles from './FilesList.module.css';

const FilesList = (props) => {
  const { files } = props;
  const fileTypes = splittingArraysObjectsByTypes(files);
  const [expanded, setExpanded] = useState(`panel${fileTypes[0].id}`);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const renderItem = (fileType) => {
    const panelId = `panel${fileType.id}`;

    return (
      <Accordion
        key={panelId}
        expanded={expanded === panelId}
        onChange={handleChange(panelId)}
        classes={{
          root: styles.content,
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`${panelId}bh-content`}
          id={`${panelId}bh-header`}
        >
          <Grid container direction="column">
            <Typography classes={{ root: styles.typeName }}>
              {fileType.name}
            </Typography>
          </Grid>
        </AccordionSummary>
        <AccordionDetails classes={{ root: styles.details }}>
          <MuiList classes={{ root: styles.list }} disablePadding>
            {fileType.files.map((file, idx) => {
              return (
                <Fragment key={file.id}>
                  <FileItem file={file} />

                  {files.length - 1 !== idx && <Divider />}
                </Fragment>
              );
            })}
          </MuiList>
        </AccordionDetails>
      </Accordion>
    );
  };

  return <div>{fileTypes.map(fileType => renderItem(fileType))}</div>;
};

FilesList.propTypes = {
  files: Type.arrayOf(
    Type.shape({
      ...FileItem.propTypes.file,
      type: Type.shape({
        id: Type.string.isRequired,
        name: Type.string.isRequired,
      }).isRequired,
    }),
  ).isRequired,
};

export default FilesList;
